export default __webpack_public_path__ + "static/media/mongo.55f389d3.png";